import type { Scene } from '../../../types/scene';
import type { CompactScene, SceneResponse, StorageScene } from '../api-types/scene';
import {
  transformCreateScenePayload,
  transformGetSceneResult,
  transformScene,
  transformUpdateScenePayload,
} from '../transformers/scene';
import type { Builder } from '../types';

const SCENES_URL = 'v1/explore/scenes';

export const sceneEndpoints = (builder: Builder) => ({
  getScenes: builder.query<CompactScene[], string>({
    query: (perspectiveId) => ({
      url: SCENES_URL,
      method: 'GET',
      params: {
        perspectiveId,
        fields: 'id,name,createdBy,createdAt,updatedAt,numOfNodes,numOfRels,version',
      },
    }),
    transformResponse: (response: { items: SceneResponse[] }) => transformGetSceneResult(response.items),
  }),
  getScene: builder.query<Scene, { sceneId: Scene['id'] }>({
    query: ({ sceneId }) => ({
      url: `${SCENES_URL}/${sceneId}`,
      method: 'GET',
    }),
    transformResponse: (response: SceneResponse) => transformScene(response),
  }),
  createScene: builder.mutation<Scene, StorageScene>({
    query: (scene) => ({
      url: SCENES_URL,
      method: 'POST',
      body: transformCreateScenePayload(scene),
    }),
    transformResponse: (response: SceneResponse) => transformScene(response),
  }),
  updateScene: builder.mutation<Scene, { sceneId: Scene['id']; update: Partial<StorageScene> }>({
    query: ({ sceneId, update }) => ({
      url: `${SCENES_URL}/${sceneId}`,
      method: 'PATCH',
      body: transformUpdateScenePayload(update),
    }),
    transformResponse: (response: SceneResponse) => transformScene(response),
  }),
  deleteScene: builder.mutation<{ id: string }, string>({
    query: (sceneId) => ({
      url: `${SCENES_URL}/${sceneId}`,
      method: 'DELETE',
    }),
  }),
});
